import styled from 'styled-components';

export const Background = styled.footer`
  padding: 80px 0 200px;
  background-color: ${({ theme }) => theme.colors.primary.main};
  color: ${({ theme }) => theme.colors.functional.white};
  & > div {
    display: flex;
    justify-content: space-between;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding: 60px 0;
    & > div {
      flex-direction: column;
    }
  }
`;
export const SocialWrapper = styled.div`
  padding-top: 6rem;
  display: flex;
  flex-direction: column;
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding-top: 2rem;
  }
`;

export const Heading = styled.span`
  display: block;
  font-weight: 700;
  padding-bottom: 1.6rem;
`;

export const Column1 = styled.div`
  width: 340px;
  max-width: 90%;
  p {
    padding-top: 1.6rem;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    order: 3;
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.md}) {
    img,
    svg {
      width: 240px;
      max-width: 90%;
    }
  }
`;
export const Column2 = styled.div`
  width: 320px;
`;
export const Column3 = styled.div`
  width: 370px;
  max-width: 100%;
  a {
    padding-bottom: 2rem;
    font-weight: 200;
    display: flex;
    color: ${({ theme }) => theme.colors.functional.white};
    &:hover {
      color: ${({ theme }) => theme.colors.functional.white};
    }
    img,
    svg {
      width: 100%;
    }
  }
  * {
    fill: ${({ theme }) => theme.colors.functional.white};
  }
  @media (max-width: ${({ theme }) => theme.breakPoints.lg}) {
    padding: 4rem 0;
  }
`;
